export interface Standpoint {
  view: string;
  user: string;
}

export interface Controversy {
  id: number;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  pro: Standpoint[];
  con: Standpoint[];
}

export const controversies: Controversy[] = [
  {
    id: 1,
    tag: "人设争议",
    title: "是「真性情耿直」还是「人设翻车」？",
    summary: "哇偶姐姐以敢说真话、怼黑粉走红，近期被扒出早年发言与其营造的耿直形象存在反差，引发「真性情」与「营业人设」之争。",
    heat: "热度 TOP 1",
    pro: [
      { view: "她能红起来本身就是因为真实，怼人从不含糊，这是很难装的。", user: "吃瓜群众A" },
      { view: "素人时期和红起来之后有反差很正常，人都是会成长的。", user: "佛系路人" },
    ],
    con: [
      { view: "红前「人间清醒」，红后「怼天怼地」，换脸式人设太明显。", user: "显微镜网友" },
      { view: "一边立耿直人设一边商务全接，鱼和熊掌都想要。", user: "清醒路人B" },
    ],
  },
  {
    id: 2,
    tag: "直播争议",
    title: "深夜直播究竟是「硬刚澄清」还是「又一次翻车」？",
    summary: "争议发酵后，哇偶姐姐开深夜直播正面回应。支持者认为是难得的担当，反对者则认为回应避重就轻、态度傲慢。",
    heat: "热度 TOP 2",
    pro: [
      { view: "风口浪尖敢开直播回应，比躲在公关稿后面强多了。", user: "直播围观者" },
      { view: "她回应的部分旧帖已经道歉，知错能改值得给一次机会。", user: "吃瓜者C" },
    ],
    con: [
      { view: "两个多小时，关键问题一个没正面回答，全程在诉苦。", user: "连夜看播的人" },
      { view: "直播里那句「黑子别来沾边」态度极差，反而火上浇油。", user: "中途退出网友" },
    ],
  },
  {
    id: 3,
    tag: "商业争议",
    title: "带货与推荐：是「真实分享」还是「恰饭变味」？",
    summary: "随着走红，哇偶姐姐开始大量带货与接推广。部分被推荐商品遭网友吐槽质量不佳，且评论区出现「不让说真话」的质疑。",
    heat: "热度 TOP 3",
    pro: [
      { view: "博主接推广是行业常态，翻车也是概率事件，不至于上纲上线。", user: "行业内幕人" },
      { view: "她至少会提前声明是广告，比起偷偷恰饭的算有底线。", user: "通勤路人" },
    ],
    con: [
      { view: "同一时间段推了七八个同类品，怎么说都像恰烂钱。", user: "测评老粉" },
      { view: "说不好就被拉黑删评，这已经不是分享而是生意。", user: "踩坑买家" },
    ],
  },
  {
    id: 4,
    tag: "公关争议",
    title: "舆论越吵越凶，她的处理是「高情商」还是「昏招」？",
    summary: "面对铺天盖地的群嘲，哇偶姐姐团队多次下场回应，时而硬刚、时而卖惨，公关节奏被质疑前后矛盾、越洗越黑。",
    heat: "热度 TOP 4",
    pro: [
      { view: "至少她在回应，很多网红翻车后直接装死，对比之下算有担当。", user: "公关从业者" },
      { view: "热度本身就是一种资源，处理得好能彻底翻盘。", user: "营销观察员" },
    ],
    con: [
      { view: "一会儿硬刚一会儿卖惨，网友不是傻子，越描越黑。", user: "老围观群众" },
      { view: "把路人和黑粉混为一谈，把所有质疑都打成黑，最败好感。", user: "被误伤路人" },
    ],
  },
];